var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgSearchFormMinus = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 32,
  height: 33,
  viewBox: "0 0 32 33",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  y: 0.5,
  width: 32,
  height: 32,
  rx: 16,
  fill: "#003399"
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M21.3333 15.5V17.5H16H10.6666V15.5H21.3333Z",
  fill: "white"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgSearchFormMinus);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/search-form-minus.95eef694a644726b85a6c1b5a6f73d1d.svg";